import { render, staticRenderFns } from "./BadgeComponent.vue?vue&type=template&id=0c3377e0&scoped=true&"
import script from "./BadgeComponent.vue?vue&type=script&lang=js&"
export * from "./BadgeComponent.vue?vue&type=script&lang=js&"
import style0 from "./BadgeComponent.vue?vue&type=style&index=0&id=0c3377e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3377e0",
  null
  
)

export default component.exports